import { IPanelScope } from "@/interfaces";
import { useContext, useEffect, useState } from "react";
import styles from "./SearchInput.module.scss";
import { FILTERS_TAB_KEY } from "@/constants";
import { ComponentsContext, IComponentsContext } from "@/contexts";
import { getTranslation } from "@/utils";

interface ISearchInputProps {
  isActive: boolean;
  criteria: string;
  handleCriteriaChange: (id: string) => void;
  scope: IPanelScope;
  customClassName?: string;
}

export const SearchInput = ({
  isActive,
  criteria,
  handleCriteriaChange,
  scope,
  customClassName,
}: ISearchInputProps) => {
  const { SearchBox } = useContext<IComponentsContext>(ComponentsContext);
  const [value, setValue] = useState<string>(criteria);
  useEffect(() => {
    setValue(criteria);
  }, [criteria]);

  const handleInputChange = (value: string) => {
    setValue(value);
    handleCriteriaChange(value);
  };

  const reset = () => {
    setValue("");
    handleCriteriaChange("");
  };

  const handleFocus = () => {
    const category = `${scope.tab}-tree`;
    const action = `Search-${scope.tab === FILTERS_TAB_KEY ? "Filter" : "Folder"}`;
    mixpanel.track(category, {
      Action: action,
    });
  };

  if (!isActive) return null;

  const searchLabel = getTranslation(
    `filters-tree.search.${scope.tab}`,
    `Search ${scope.tab.toUpperCase()}`,
  );

  return SearchBox ? (
    <SearchBox
      placeholder={searchLabel}
      aria-label={searchLabel}
      on-change={(e: any) => handleInputChange(e.target.value)}
      on-focus={handleFocus}
      on-clear-click={reset}
      value={value}
      class={customClassName ? customClassName : styles["custom-styles"]}
    />
  ) : null;
};
